<div class="float-button-group">
    <a class="btn-floating float" (click)="displayOptions()" [ngClass]="{'rotate':isButtonListVisible}">
        <em class="fa fa-plus my-float"></em>
    </a>
    <ul class="dropdown-menu-right" [ngClass]="{'open':isButtonListVisible}">
        <li><button class="btn btn-floating">Unificar</button></li>
        <li><button class="btn btn-floating">Informe Veraz</button></li>
        <li><button class="btn btn-floating">Otro</button></li>
    </ul>
</div>
